import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'litmus-seperator',
    templateUrl: './litmus-seperator.component.html',
    styleUrls: ['./litmus-seperator.component.scss'],
    standalone: false
})
export class LitmusSeperatorComponent implements OnInit, OnChanges {
  @Input() text:string="";
  isNameSeprator:boolean = false;
  
  constructor(){}
  ngOnInit(): void {
    
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.text && this.text != ""){
      this.isNameSeprator = true;
    }
  }
}
